import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Form,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
} from "reactstrap";

import { Btn, H5 } from "../../../AbstractElements";

function InvoiceStepOne({ handleNext }) {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
  const [selectedFile, setSelectedFile] = useState(null);
  const [newFileSelected, setNewFileSelected] = useState(false);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      let file = e.target.files[0];
      setSelectedFile(file);
      setNewFileSelected(true);
    } else {
      setSelectedFile(null);
      setNewFileSelected(false);
    }
  };

  const onSubmit = (data) => {
    data.file = selectedFile;
    console.log(data);
    handleNext();
  };

  return (
    <>
      <Col sm="12">
        <Card className="card-absolute">
          <CardHeader className="bg-primary">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <H5>Invoice Details</H5>
            </div>
          </CardHeader>
          <CardBody>
            <Form onSubmit={handleSubmit(onSubmit)} className="theme-form">
              <Row>
                <Col md="4">
                  <FormGroup>
                    <Label for="invoice_number">Invoice Number</Label>
                    <Controller
                      name="invoice_number"
                      control={control}
                      defaultValue=""
                      rules={{ required: "Invoice number is required" }}
                      render={({ field }) => (
                        <Input
                          {...field}
                          type="text"
                          id="invoice_number"
                          placeholder="Enter invoice number"
                          invalid={!!errors.invoice_number}
                        />
                      )}
                    />
                    {errors.invoice_number && (
                      <div className="text-danger">
                        {errors.invoice_number.message}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <Label for="start_date">Start Date</Label>
                    <Controller
                      name="start_date"
                      control={control}
                      defaultValue=""
                      rules={{ required: "Start date is required" }}
                      render={({ field }) => (
                        <Input
                          {...field}
                          type="date"
                          id="start_date"
                          invalid={!!errors.start_date}
                        />
                      )}
                    />
                    {errors.start_date && (
                      <div className="text-danger">
                        {errors.start_date.message}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <Label for="end_date">End Date</Label>
                    <Controller
                      name="end_date"
                      control={control}
                      defaultValue=""
                      rules={{ required: "End date is required" }}
                      render={({ field }) => (
                        <Input
                          {...field}
                          type="date"
                          id="end_date"
                          invalid={!!errors.end_date}
                        />
                      )}
                    />
                    {errors.end_date && (
                      <div className="text-danger">
                        {errors.end_date.message}
                      </div>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="4">
                  <FormGroup>
                    <Label for="amount">Amount</Label>
                    <Controller
                      name="amount"
                      control={control}
                      defaultValue=""
                      rules={{ required: "Amount is required" }}
                      render={({ field }) => (
                        <Input
                          {...field}
                          type="number"
                          id="amount"
                          placeholder="Enter amount"
                          invalid={!!errors.amount}
                        />
                      )}
                    />
                    {errors.amount && (
                      <div className="text-danger">{errors.amount.message}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <Label for="currency">Currency</Label>
                    <Controller
                      name="currency"
                      control={control}
                      defaultValue=""
                      rules={{ required: "Currency is required" }}
                      render={({ field }) => (
                        <Input
                          {...field}
                          type="text"
                          id="currency"
                          placeholder="Enter currency"
                          invalid={!!errors.currency}
                        />
                      )}
                    />
                    {errors.currency && (
                      <div className="text-danger">
                        {errors.currency.message}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <Label for="status">Status</Label>
                    <Controller
                      name="status"
                      control={control}
                      defaultValue=""
                      rules={{ required: "Status is required" }}
                      render={({ field }) => (
                        <Input
                          {...field}
                          type="text"
                          id="status"
                          placeholder="Enter status"
                          invalid={!!errors.status}
                        />
                      )}
                    />
                    {errors.status && (
                      <div className="text-danger">{errors.status.message}</div>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="4">
                  <FormGroup>
                    <Label for="file">File</Label>
                    <Controller
                      name="file"
                      control={control}
                      render={({ field }) => (
                        <Input
                          {...field}
                          type="file"
                          id="file"
                          onChange={(e) => {
                            handleFileChange(e);
                            field.onChange(e);
                          }}
                          invalid={!!errors.file}
                        />
                      )}
                    />
                    {errors.file && (
                      <div className="text-danger">{errors.file.message}</div>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <CardFooter className="text-end">
                <Btn
                  attrBtn={{
                    color: "primary",
                    className: "m-r-15",
                    type: "submit",
                  }}
                >
                  Next Step
                </Btn>
              </CardFooter>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  );
}

export default InvoiceStepOne;
